import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import React, { useEffect } from 'react';

const Base = ({children}: {children?: any}) => {
  // Load script.js file
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '/assets/js/script.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    }
  }, []);




  return <>
    <main className='main-wrapper'>
      <Header />
      <Sidebar />
      <div className='page-wrapper'>
        <div className='content container-fluid'>
          {children}
        </div>
      </div>
    </main>
  </>;
}

export default Base;
